<template>
  <div>
    <iframe id="sessionRenewal" :src="authorizeEndpoint" style="border: none !important;" />
  </div>
</template>

<script>
import ConfigService from '@/services/ConfigService'

export default {
  name: 'AuthFrame',
  data () {
    return {
      authorizeEndpoint: ConfigService.reauthorizeSilentlyUrl()
    }
  }
}
</script>
